/**
 * Telemetry service — fire-and-forget user journey event logging.
 * Never throws or blocks the UI. Silently swallows all errors.
 * See imp_mds/TELEMETRY.md for full event type reference.
 */

import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';

function getToken(): string | null {
  const storageType = localStorage.getItem('auth_storage_type');
  const storage = storageType === 'session' ? sessionStorage : localStorage;
  return storage.getItem('access_token');
}

export interface TelemetryEvent {
  session_id: string;
  event_type: string;
  metadata?: Record<string, unknown>;
  duration_seconds?: number;
}

/** Generate a new session ID. Call once per fitting session (store in component state or sessionStorage). */
export function newSessionId(): string {
  return crypto.randomUUID();
}

/** Fire-and-forget: log a telemetry event. Never awaited by callers. */
export function logEvent(event: TelemetryEvent): void {
  const token = getToken();
  const headers: Record<string, string> = { 'Content-Type': 'application/json' };
  if (token) headers['Authorization'] = `Bearer ${token}`;

  axios
    .post(`${API_BASE_URL}/api/v1/telemetry/event`, event, { headers })
    .catch(() => {
      // Intentionally swallowed — telemetry must never break the app
    });
}
